module.exports = __webpack_public_path__ + "static/media/h5_july.cf54ac14.png";